import { Directive, OnDestroy } from '@angular/core';
import { Subject, Observable, MonoTypeOperatorFunction } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

//o melhor seria um basecomponet extendend a essa classe
@Directive()
export abstract class BaseUnsubscribeComponent implements OnDestroy {
    protected _unsubscribeAll = new Subject<void>();

    /**
     * Método simplificado para usar nos pipes
     * Em vez de .pipe(takeUntil(this._unsubscribeAll))
     * Agora você pode usar .pipe(this.untilDestroy())
     */
    protected untilDestroy<T>(): MonoTypeOperatorFunction<T> {
        return takeUntil<T>(this._unsubscribeAll);
    }

    unsubscribeAll() {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    ngOnDestroy(): void {
        this.unsubscribeAll();
    }
}
